import * as React from "react"
import type { IconProps } from "../types"

const Pencil = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M13.5 6.00019L15.5858 3.9144C16.3668 3.13335 17.6332 3.13335 18.4142 3.9144L20.0858 5.58597C20.8668 6.36702 20.8668 7.63335 20.0858 8.4144L18 10.5002M13.5 6.00019L3.29289 16.2073C3.10536 16.3948 3 16.6492 3 16.9144V21.0002H7.08579C7.351 21.0002 7.60536 20.8948 7.79289 20.7073L18 10.5002M13.5 6.00019L18 10.5002"
        />
      </svg>
    )
  }
)
Pencil.displayName = "Pencil"

export default Pencil
